import { DhlEcsDistributionCenter } from "./carriers-and-services";

export interface DhlPickupCosts {
  cargoVanNear: number;
  cargoVanFar: number;
  straightTruckNear: number;
  straightTruckFar: number;
}

export const DHL_PICKUP_COSTS_BY_DC: Record<
  DhlEcsDistributionCenter,
  DhlPickupCosts
> = {
  [DhlEcsDistributionCenter.USATL1]: {
    cargoVanNear: 90,
    cargoVanFar: 160,
    straightTruckNear: 180,
    straightTruckFar: 225,
  },
  [DhlEcsDistributionCenter.USBOS1]: {
    cargoVanNear: 90,
    cargoVanFar: 200,
    straightTruckNear: 240,
    straightTruckFar: 380,
  },
  [DhlEcsDistributionCenter.USBWI1]: {
    cargoVanNear: 205,
    cargoVanFar: 320,
    straightTruckNear: 280,
    straightTruckFar: 385,
  }, // Baltimore/DC area
  [DhlEcsDistributionCenter.USCAK1]: {
    cargoVanNear: 55,
    cargoVanFar: 140,
    straightTruckNear: 90,
    straightTruckFar: 150,
  },
  [DhlEcsDistributionCenter.USCVG1]: {
    cargoVanNear: 55,
    cargoVanFar: 140,
    straightTruckNear: 90,
    straightTruckFar: 150,
  },
  [DhlEcsDistributionCenter.USDEN1]: {
    cargoVanNear: 115,
    cargoVanFar: 145,
    straightTruckNear: 200,
    straightTruckFar: 240,
  },
  [DhlEcsDistributionCenter.USDFW1]: {
    cargoVanNear: 105,
    cargoVanFar: 170,
    straightTruckNear: 170,
    straightTruckFar: 240,
  },
  [DhlEcsDistributionCenter.USEWR1]: {
    cargoVanNear: 140,
    cargoVanFar: 225,
    straightTruckNear: 255,
    straightTruckFar: 350,
  },
  [DhlEcsDistributionCenter.USIAH1]: {
    cargoVanNear: 100,
    cargoVanFar: 145,
    straightTruckNear: 110,
    straightTruckFar: 195,
  },
  [DhlEcsDistributionCenter.USLAX1]: {
    cargoVanNear: 55,
    cargoVanFar: 235,
    straightTruckNear: 150,
    straightTruckFar: 330,
  },
  [DhlEcsDistributionCenter.USMCI1]: {
    cargoVanNear: 115,
    cargoVanFar: 150,
    straightTruckNear: 210,
    straightTruckFar: 245,
  },
  [DhlEcsDistributionCenter.USMCO1]: {
    cargoVanNear: 90,
    cargoVanFar: 195,
    straightTruckNear: 210,
    straightTruckFar: 340,
  },
  [DhlEcsDistributionCenter.USORD1]: {
    cargoVanNear: 120,
    cargoVanFar: 190,
    straightTruckNear: 270,
    straightTruckFar: 340,
  },
  [DhlEcsDistributionCenter.USPHX1]: {
    cargoVanNear: 90,
    cargoVanFar: 195,
    straightTruckNear: 180,
    straightTruckFar: 225,
  },
  [DhlEcsDistributionCenter.USRDU1]: {
    cargoVanNear: 90,
    cargoVanFar: 160,
    straightTruckNear: 180,
    straightTruckFar: 225,
  }, // Charlotte area rates
  [DhlEcsDistributionCenter.USSEA1]: {
    cargoVanNear: 80,
    cargoVanFar: 160,
    straightTruckNear: 265,
    straightTruckFar: 350,
  },
  [DhlEcsDistributionCenter.USSFO1]: {
    cargoVanNear: 80,
    cargoVanFar: 160,
    straightTruckNear: 265,
    straightTruckFar: 350,
  },
  [DhlEcsDistributionCenter.USSLC1]: {
    cargoVanNear: 240,
    cargoVanFar: 345,
    straightTruckNear: 420,
    straightTruckFar: 585,
  },
  [DhlEcsDistributionCenter.CNYYZ1]: {
    cargoVanNear: 90,
    cargoVanFar: 160,
    straightTruckNear: 180,
    straightTruckFar: 225,
  }, // Toronto - using default rates
};

export const DEFAULT_DHL_PICKUP_COSTS: DhlPickupCosts = {
  cargoVanNear: 90,
  cargoVanFar: 160,
  straightTruckNear: 180,
  straightTruckFar: 225,
};
